/**
 * What the page remembers of the last import started from this browser: when, and whether it
 * worked, with the counts. Never the file or anything in it. The server keeps no such record the
 * page can read, so this is per browser and per organization (L6).
 */
export type LastImport = {
  readonly at: string;
  readonly ok: boolean;
  readonly cards?: number;
  readonly vehicles?: number;
  readonly suppliers?: number;
};

const key = (organizationId: string | undefined) => `expenses.import.last.${organizationId ?? ''}`;

export function readLastImport(organizationId: string | undefined): LastImport | null {
  try {
    const raw = window.localStorage.getItem(key(organizationId));
    if (raw === null) return null;
    const value = JSON.parse(raw) as Partial<LastImport>;
    return typeof value.at === 'string' && typeof value.ok === 'boolean'
      ? (value as LastImport)
      : null;
  } catch {
    return null;
  }
}

export function writeLastImport(organizationId: string | undefined, last: LastImport): void {
  try {
    window.localStorage.setItem(key(organizationId), JSON.stringify(last));
  } catch {
    // A browser that refuses storage just shows no «ultima importazione».
  }
}
